__turbopack_context__.v({
  "fade-in": "Hero-module-scss-module__twV7AW__fade-in",
  "footer": "Hero-module-scss-module__twV7AW__footer",
  "gradient": "Hero-module-scss-module__twV7AW__gradient",
  "hero": "Hero-module-scss-module__twV7AW__hero",
  "heroContent": "Hero-module-scss-module__twV7AW__heroContent",
  "heroRootGutter": "Hero-module-scss-module__twV7AW__heroRootGutter",
  "heroThick": "Hero-module-scss-module__twV7AW__heroThick",
  "heroTightLtMd": "Hero-module-scss-module__twV7AW__heroTightLtMd",
  "highlight": "Hero-module-scss-module__twV7AW__highlight",
  "highlights": "Hero-module-scss-module__twV7AW__highlights",
  "no-transform": "Hero-module-scss-module__twV7AW__no-transform",
  "rotate": "Hero-module-scss-module__twV7AW__rotate",
});
